/* PDP header, mobile only — see assets/suti-pdp-mobile.css.

   Four nodes move above the gallery, stacked title / subtitle / rating, with the
   price sitting on the rating line at the right margin. They MOVE rather than
   get cloned, so the rating keeps the review-jump handler bound to it and the
   price element keeps whatever Horizon has wired to it for variant changes.
   Nothing is rebuilt, so nothing can fall out of sync.

   The template is a 75KB JSON file, past the size the API can rewrite, so the
   order has to be changed in the DOM rather than in the block order. That also
   keeps it mobile-only without touching the desktop layout at all.

   Every node remembers the parent and next sibling it came from, and desktop
   restores them in REVERSE order — forwards would try to insert the title before
   a rating that has not been put back yet. */
(function () {
  'use strict';

  var grid = document.querySelector('.product-information__grid');
  if (!grid) return;

  var col = grid.querySelector('.product-details .group-block-content');
  if (!col) return;

  var title = col.querySelector('a.contents[ref="productTitleLink"]') || col.querySelector('a.contents');
  var rating = col.querySelector('.rating-wrapper');
  var price = col.querySelector('product-price');

  /* The subtitle has no class of its own — it is the bare div holding the h6. */
  var sub = null;
  [].forEach.call(col.children, function (el) {
    if (!sub && el.tagName === 'DIV' && !el.className && el.querySelector('h6')) sub = el;
  });

  var moved = [title, rating, sub, price].filter(Boolean);
  if (!moved.length) return;

  var home = moved.map(function (el) {
    return { el: el, parent: el.parentNode, next: el.nextSibling };
  });

  var head = document.createElement('div');
  head.className = 'suti-pdph';
  var row = document.createElement('div');
  row.className = 'suti-pdph__row';

  function toMobile() {
    if (head.parentNode === grid) return;
    /* Title and subtitle run full width; the rating shares its line with the
       price. appendChild moves a node that is already placed, so re-running
       this is harmless. The row is appended LAST so it lands under the
       subtitle — it used to be created inside head and so came first. */
    if (title) head.appendChild(title);
    if (sub) head.appendChild(sub);
    if (rating) row.appendChild(rating);
    if (price) row.appendChild(price);
    head.appendChild(row);
    grid.insertBefore(head, grid.firstChild);
  }

  function toDesktop() {
    if (head.parentNode !== grid) return;
    home.slice().reverse().forEach(function (h) {
      /* If anything else on the page has moved the anchor since — an app, a
         section re-render — fall back to appending rather than throwing and
         leaving the column half restored. */
      var anchor = h.next && h.next.parentNode === h.parent ? h.next : null;
      h.parent.insertBefore(h.el, anchor);
    });
    if (head.parentNode) head.parentNode.removeChild(head);
  }

  var mq = window.matchMedia('(max-width: 749px)');
  function sync() { if (mq.matches) { toMobile(); } else { toDesktop(); } }

  sync();

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
  /* Belt and braces for tablets, where rotation crosses the breakpoint and some
     browsers are late with the media query event. */
  window.addEventListener('orientationchange', function () { setTimeout(sync, 50); });
})();
